import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../../common/types';
import { PresaveCampaign } from '../../../../../../redux/api/fymAPI.types';
import { PresaveStatusBadge } from '../../../../presave/PresaveStatusBadge';
import { PresaveWidgetFormContainer } from './PresaveWidgetFormContainer';

interface PresaveWidgetClosedViewProps {
  accountId: number;
  smartLinkId: number;
  campaign: PresaveCampaign;
  isLoading: boolean;
  onDelete: () => void;
}

/**
 * A campaign that has landed, run out or been called off. Nothing here is
 * editable: fans have already been told what this page said, and the release
 * links are the manage screen's business. The block can still be deleted.
 */
const PresaveWidgetClosedViewComponent: React.FC<PresaveWidgetClosedViewProps> = ({
  accountId,
  smartLinkId,
  campaign,
  isLoading,
  onDelete,
}) => {
  const intl = useIntl();

  return (
    <PresaveWidgetFormContainer
      accountId={accountId}
      smartLinkId={smartLinkId}
      isLoading={isLoading}
      onDelete={onDelete}
    >
      <div className="d-flex align-items-center justify-content-between mb-3">
        <span>{campaign.trackTitle}</span>
        <PresaveStatusBadge status={campaign.status} />
      </div>
      <div className="mb-1">{campaign.artistName}</div>
      <div className="mb-3">
        {intl.formatMessage(
          { id: 'app.sml.presave.block.released_on', defaultMessage: 'Out on {date}' },
          {
            date: intl.formatDate(campaign.releaseDate, {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
              timeZone: 'UTC',
            }),
          }
        )}
      </div>
      <div className="text-muted">
        {intl.formatMessage({
          id: 'app.sml.presave.block.closed_note',
          defaultMessage:
            'This campaign is finished, so the block cannot be edited. The manage screen shows who signed up.',
        })}
      </div>
    </PresaveWidgetFormContainer>
  );
};

export const PresaveWidgetClosedView = TypedMemo(PresaveWidgetClosedViewComponent);
